import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { replace } from "connected-react-router";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { bool, func, string, arrayOf, number, shape } from "prop-types";

import I18n from "pages/_components/I18n";
import Scroll from "pages/_components/Scroll";
import Movement from "pages/accounts/_components/Movement";
import ProductList from "pages/_components/product/List";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";

class Movements extends Component {
    static propTypes = {
        accountId: string.isRequired,
        radioTab: string.isRequired,
        dispatch: func.isRequired,
        filters: shape({}).isRequired,
        pageNumber: number.isRequired,
        accountCurrency: number.isRequired,
        isDesktop: bool.isRequired,
        lastPage: bool.isRequired,
        firstFetched: bool.isRequired,
        movements: arrayOf(shape({})).isRequired,
        isFetchingMovements: bool.isRequired,
        moreMovements: bool.isRequired,
        showBalance: bool.isRequired,
    };

    state = {
        columns: this.props.isDesktop ? 6 : 2,
        rows: this.props.isDesktop ? 1 : 3,
    };

    fetchMoreMovements = () => {
        const { accountId, dispatch } = this.props;
        let { filters, pageNumber } = this.props;

        pageNumber += 1;
        filters = { ...filters, pageNumber };
        dispatch(accountsActions.fetchMoreMovements(accountId, filters));
    };

    handleClick = () => {
        this.fetchMoreMovements();
    };

    handleFiletrClick = () => {
        const { dispatch, accountId } = this.props;
        dispatch(replace(`/accounts/${accountId}/filters`));
    };

    handleMovementClick = (movement) => {
        const { dispatch } = this.props;

        dispatch(accountsActions.setSelectedMovement(movement));
    };

    renderItem = (movement) => {
        const { accountCurrency, isDesktop, showBalance, accountId, radioTab } = this.props;
        const { columns, rows } = this.state;
        return (
            <GridTable.Container
                columns={columns}
                rows={rows}
                renderAs={Link}
                to={`/accounts/${accountId}/movement/${movement.receipt}/${radioTab}`}
                onClick={() => this.handleMovementClick(movement)}
                key={movement.receipt}>
                <Movement
                    accountCurrency={accountCurrency}
                    isDesktop={isDesktop}
                    movement={movement}
                    showBalance={showBalance}
                />
            </GridTable.Container>
        );
    };

    renderList = (list, renderLoadMore) => {
        const { isDesktop, moreMovements, accountId, showBalance } = this.props;
        const isEmpty = list.length === 0;
        const { columns, rows } = this.state;

        return (
            <>
                <GridTable className="scrollable section-accounts text-neutral movements-table underlined">
                    {isDesktop && (
                        <GridTable.Header style={{ position: "sticky", top: 0 }}>
                            <GridTable.Container key="Movements" columns={columns} rows={rows}>
                                <GridTable.Data columnStart={1} rowStart={1} alignX="flex-start" alignY="flex-start">
                                    <I18n id="tableHeader.date" />
                                </GridTable.Data>
                                <GridTable.Data
                                    columnStart={2}
                                    rowStart={isDesktop ? 1 : 2}
                                    alignX="center"
                                    alignY="flex-start">
                                    <I18n id="tableHeader.receipt" />
                                </GridTable.Data>
                                <GridTable.Data
                                    columnStart={3}
                                    rowStart={isDesktop ? 1 : 3}
                                    alignX="center"
                                    alignY="flex-start">
                                    <I18n id="tableHeader.detail" />
                                </GridTable.Data>
                                <GridTable.Data columnStart={4} rowStart={1} alignX="center" alignY="flex-start">
                                    <I18n id="tableHeader.amount" />
                                </GridTable.Data>
                                {showBalance && (
                                    <GridTable.Data columnStart={5} rowStart={1} alignX="center" alignY="flex-start">
                                        <I18n id="tableHeader.balance" />
                                    </GridTable.Data>
                                )}
                                <GridTable.Data columnStart={6} rowStart={1} alignX="center" alignY="flex-start" />
                            </GridTable.Container>
                        </GridTable.Header>
                    )}
                    <GridTable.Body>
                        {isDesktop ? (
                            list
                        ) : (
                            <Scroll
                                {...this.props}
                                fetchMoreData={this.fetchMoreMovements}
                                lastPage={!moreMovements}
                                items={list}
                                searchMore={
                                    <Button
                                        className="btn btn-block btn-link"
                                        onClick={this.handleFiletrClick}
                                        key="searchMoreMovementsButton"
                                        to={`/accounts/${accountId}/filters`}
                                        label="accounts.searchMovements"
                                    />
                                }
                                endOfListItem={
                                    <div key="lastItem" className="text-center no-more-data">
                                        <p>
                                            <I18n id="accounts.movements.noMoreMovements" />
                                        </p>
                                    </div>
                                }
                                removeListenersWhenPulled
                                isInfiniteScroll
                            />
                        )}
                    </GridTable.Body>
                </GridTable>
                {isEmpty && renderLoadMore()}
            </>
        );
    };

    render() {
        const { firstFetched, moreMovements, movements, isFetchingMovements, isDesktop, filters } = this.props;

        return (
            <ProductList
                fetching={isFetchingMovements}
                items={movements || []}
                renderItem={this.renderItem}
                lastPage={!moreMovements}
                onLoadMoreClick={this.handleClick}
                firstFetched={firstFetched}
                filters={filters}
                noMoreDataText={isDesktop ? "accounts.movements.noMoreMovements" : ""}
                loadMoreText={isDesktop ? "accounts.searchMovements" : ""}
                noDataText="accounts.movements.none"
                noFiltersDataText="accounts.movements.filters.none">
                {this.renderList}
            </ProductList>
        );
    }
}

const mapStateToProps = (state) => ({
    account: accountsSelectors.getSelectedAccount(state),
    fetching: accountsSelectors.getFetching(state),
    filters: accountsSelectors.getFilters(state),
    firstFetched: accountsSelectors.getFirstFetched(state),
    movements: accountsSelectors.getMovements(state),
    moreMovements: accountsSelectors.getMoreMovements(state),
    pageNumber: accountsSelectors.getPageNumber(state),
    isFetchingMovements: accountsSelectors.getFetchingMovements(state),
});

export default connect(mapStateToProps)(Movements);
